/// <reference path="../ObjectDataBuilder.ts" />
/// <reference path="../Navigation.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class UnitBuilder
			extends ObjectDataBuilder<Wollmilch.Data.Unit>
		{

			private m_Form: ui.Form.Form;
			private	m_UnitName: ui.Box.Box;
			private	m_General: ui.Box.Box;
			private	m_Facilities: ui.Box.Box;
			private	m_Others: ui.Box.Box;

			public constructor( data: Wollmilch.Data.Unit )
			{
				super( data );

				this.m_UnitName		= new ui.Box.Box();
				this.m_General		= new ui.Box.Box();
				this.m_Facilities	= new ui.Box.Box();
				this.m_Others			= new ui.Box.Box();

				// Update
				this.m_Form = new ui.Form.Form(
					{
						action: 'unit/update/' + this.m_Data.ID,
						method: 'PATCH',
						static: false,
						notSwitchable: true,
						editButtonContext: 'primary',
						submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
						{
							new Wollmilch.AJAX(
								{
									method,
									url: action,
									data: parameter,
									on:
									{
										success: ( text: string ): void =>
										{
											const obj = Wollmilch.jsonize( text );

											if ( obj && obj.success === true )
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.UNIT.success_edit' ) ], context: 'success' });
											}
											else
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.UNIT.error_edit' ) ], context: 'danger' });
											}
										}
									}
								},
								Wollmilch.AJAXCallbase_e.REALTOR
							).send();

						}
					}
				);
				this.m_Form.Initialize();
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation: Navigation ): UnitBuilder
			{
				this.m_Form.rebuild( root.empty() );

				this.showCompleteUnit();

				return this;
			}

			private showCompleteUnit(): void
			{

				this.showUnitName();
				this.showUnitGeneral();
				this.showUnitFacilities();
				this.showUnitOthers();

				// Button
				new ui.Box.Box()
					.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
					// .append( $( this.m_Form.Buttons.reset.getElement() ).text( app.getMessage( 'Aux.RESET_BTN' ) ) )
					.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
				.appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

			}

			private showUnitName(): void
			{
				this.m_UnitName.clearTitle();
				this.m_UnitName.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.UNIT.name' ) );
				this.m_UnitName.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Name der Wohneinheit
				const fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' ).appendTo( this.m_UnitName.Root() );
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Name,
						{
							name: 'name',
							placeholder: '',
							required: true
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-12' ]
				);

			}

			private showUnitGeneral(): void
			{
				this.m_General.clearTitle();
				this.m_General.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.UNIT.General' ) );
				this.m_General.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Wohnfläche
				const fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.General.LivingSpace' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_General.Root() );
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.General.LivingSpace || '',
						{
							name: 'General.LivingSpace',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Bautenstand
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'General.ConstructionRate',
							required: false,
							inline: 3,
							value: this.m_Data.Data.General.ConstructionRate || undefined,
							radioButtons:
							[
								{
									value: 'underConstruction',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.ConstructionRate.underConstruction' ),
									descriptor: {}
								},
								{
									value: 'Renovation',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.ConstructionRate.Renovation' ),
									descriptor: {}
								},
								{
									value: 'finished',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.ConstructionRate.finished' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.General.ConstructionRate' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_General.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Bezugsstand
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'General.TenancyRate',
							required: false,
							inline: 3,
							value: this.m_Data.Data.General.TenancyRate || undefined,
							radioButtons:
							[
								{
									value: 'full',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.TenancyRate.full' ),
									descriptor: {}
								},
								{
									value: 'empty',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.TenancyRate.empty' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.General.TenancyRate' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_General.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

			}

			private showUnitFacilities(): void
			{
				this.m_Facilities.clearTitle();
				this.m_Facilities.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.UNIT.Facilities' ) );
				this.m_Facilities.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Küche
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				const fg = ui.$$.div().addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.Facilities.Kitchen' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Facilities.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Facilities.Kitchen',
							value: [
								'Realtor.OBJECT.INPUT.UNIT.Facilities.Kitchen.step1',
								'Realtor.OBJECT.INPUT.UNIT.Facilities.Kitchen.step2',
								'Realtor.OBJECT.INPUT.UNIT.Facilities.Kitchen.step3',
								'Realtor.OBJECT.INPUT.UNIT.Facilities.Kitchen.step4',
								'Realtor.OBJECT.INPUT.UNIT.Facilities.Kitchen.step5'
							],
							sentinal: 'Realtor.OBJECT.no-value',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Facilities.Kitchen ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Bad
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Facilities.Bathroom )
					{
						if ( this.m_Data.Data.Facilities.Bathroom[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Facilities.Bathroom',
								required: false,
								inline: 3,
								value: values,
								checkboxes:
								[
									{
										name: 'wc',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Facilities.Bathroom.wc' ),
										descriptor: {}
									},
									{
										name: 'shower',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Facilities.Bathroom.shower' ),
										descriptor: {}
									},
									{
										name: 'bathtub',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Facilities.Bathroom.bathtub' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.Facilities.Bathroom' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Facilities.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Heizung
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Facilities.Heating )
					{
						if ( this.m_Data.Data.Facilities.Heating[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Facilities.Heating',
								required: false,
								inline: 3,
								value: values,
								checkboxes:
								[
									{
										name: 'radiator',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Facilities.Heating.radiator' ),
										descriptor: {}
									},
									{
										name: 'floorheating',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Facilities.Heating.floorheating' ),
										descriptor: {}
									},
									{
										name: 'airheating',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Facilities.Heating.airheating' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.Facilities.Heating' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Facilities.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

			}

			private showUnitOthers(): void
			{
				this.m_Others.clearTitle();
				this.m_Others.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.UNIT.Others' ) );
				this.m_Others.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Nutzung
				let addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'Others.Usage',
							required: false,
							inline: 4,
							value: this.m_Data.Data.Others.usage,
							radioButtons:
							[
								{
									value: 'ownerusage',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Usage.ownerusage' ),
									descriptor: {}
								},
								{
									value: 'foreignusage',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Usage.foreignusage' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.Others.Usage' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Others.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Fenster
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Others.Window )
					{
						if ( this.m_Data.Data.Others.Window[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Others.Window',
								required: false,
								inline: 4,
								value: values,
								checkboxes:
								[
									{
										name: 'singleglazed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.singleglazed' ),
										descriptor: {}
									},
									{
										name: 'doubleglazed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.doubleglazed' ),
										descriptor: {}
									},
									{
										name: 'tripleglazed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.tripleglazed' ),
										descriptor: {}
									},
									{
										name: 'soundproofed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.soundproofed' ),
										descriptor: {}
									},
									{
										name: 'mirrored',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.mirrored' ),
										descriptor: {}
									},
									{
										name: 'wood',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.wood' ),
										descriptor: {}
									},
									{
										name: 'alu',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.alu' ),
										descriptor: {}
									},
									{
										name: 'plastic',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Window.plastic' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.Others.Window' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Others.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Mitbenutzung
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Others.Others )
					{
						if ( this.m_Data.Data.Others.Others[ i ] ) { values.push( i ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Others.Others',
								required: false,
								inline: 4,
								value: values,
								checkboxes:
								[
									{
										name: 'BasementUsage',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.BasementUsage' ),
										descriptor: {}
									},
									{
										name: 'GardenUsage',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.GardenUsage' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append(
							ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.Others.Use' ) )
							.addClass( 'control-label col-xs-12 col-md-2' )
						).appendTo( this.m_Others.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Garagen
				let fg = ui.$$.div().append(ui.$$.br())
				.addClass( 'form-group clearfix' ).append(
					ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.Garage' ) )
					.addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_Others.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Others.Garage,
						{
							name: 'Others.Garage',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-1' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append(
					ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.UndergroundGarage' ) )
					.addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_Others.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Others.UndergroundGarage,
						{
							name: 'Others.UndergroundGarage',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-1' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append(
					ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.Others.ParkingSpace' ) )
					.addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_Others.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Others.ParkingSpace,
						{
							name: 'Others.ParkingSpace',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-1' ]
				);

				// Besondere Ausstattung
				fg = ui.$$.div().appendTo( this.m_Form.Root() ).addClass( 'form-group clearfix' ).append(
					ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.UNIT.General.Equipment' ) )
					.addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_Others.Root() );

				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.General.Equipment || '',
						{
							name: 'General.Equipment',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ]
				);
			}

		}
	}
}
